// extracted by mini-css-extract-plugin
export default {"cls1":"YWdiPkoSJKBtq5xbp8Wt","cls2":"oB2Dzw9kD27DjIPDzVw7 YWdiPkoSJKBtq5xbp8Wt"};